import { render, staticRenderFns } from "./LKPublicationsFormdataHeader.vue?vue&type=template&id=05e704f2&"
import script from "./LKPublicationsFormdataHeader.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataHeader.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpacer,VTooltip})
